import { action, Action } from 'easy-peasy';
import { CoreAPI } from '@meitu/saas-editor-core/es/framework';
import { DEFAULT_DPI, setDPI } from '@meitu/saas-editor-core/es/utils/unit-kit';
import { CanvasType, IDynamicInfoProps, StageType, StretchOptionType } from '@meitu/saas-editor-core/es/version-types';
import { editor } from '@/instance';
import { TemplateResponseData } from '@/types';

interface IAiPPTInfoProps {
    // AI生成图剩余次数
    // aiImageRemain: number;

    // 生成风格
    aiStyleSelect: {
        name: string;
        value: number;
    }[];

    // AI文生文：功能类型
    aiFuncSelect: {
        name: string;
        value: number;
        icon: string;
    }[];

    // 生成语调
    ai_tone_select: {
        name: string;
        value: number;
    }[];
}
interface IInitTemplateInfo {
    /** 预览图地址 */
    preview: string;

    /** 模板版本号 */
    version: string;

    /** 模板id */
    id: string;

    /** 模板名称 */
    templateName: string;

    /** 接口下发的模板类型 */
    canvasType: CanvasType;

    aiPPTInfo?: IAiPPTInfoProps;

    /** 页面一进来请求的模板对应的素材id， 查找canvasType用的  */
    originMaterialId?: string;

    /** ai生成的图片map  */

    aiPicMapByLayerId?: { [key: string]: any[] };

    /** 分辨率 */
    resolution: number;

    extraInfo?: { [key: string]: any };

    dynamicBgInfo?: {
        dynamicInfo: IDynamicInfoProps;
        previewUrl: string;
    };

    /** 配置是否为数组 */
    isArray?: boolean;

    psdFileUrl?: string;

    qrCode?: string; // 真正的模板id
    templateId?: string;
    mcpSourceId?: string;

    /** 使用水印 */
    useWatermark: boolean;

    tagInfoId?: string;
}
interface ITemplate {
    /**模板数据 */
    template: TemplateResponseData | undefined;
}
export interface ITemplateModel extends IInitTemplateInfo, ITemplate {
    destroy: Action<ITemplateModel>;
    setExtraInfo: Action<ITemplateModel, { [key: string]: any }>;
    /** 设置模板数据 */
    setTemplate: Action<ITemplateModel, TemplateResponseData | undefined>;
    /** 设置模板名称 */
    setTemplateName: Action<ITemplateModel, string>;

    /** 设置模板id */
    setTemplateId: Action<ITemplateModel, string>;

    /** 设置版本号 */
    setVersion: Action<ITemplateModel, string>;

    /** 设置预览图 */
    setPreview: Action<ITemplateModel, string>;

    setCanvasType: Action<ITemplateModel, CanvasType>;

    setResolution: Action<ITemplateModel, number>;

    initTemplateInfo: Action<ITemplateModel, IInitTemplateInfo>;

    setAiImageRemain: Action<ITemplateModel, number>;
    setAiImageInfo: Action<ITemplateModel, IAiPPTInfoProps>;

    setOriginMaterialId: Action<ITemplateModel, string>;

    setAiPicMapByLayerId: Action<ITemplateModel, { [key: string]: any[] }>;
    isReplaceTemplate: boolean;
    setIsReplaceTemplate: Action<ITemplateModel, boolean>;

    canShowReplaceAiPPTCollapse: boolean;
    setCanReplaceAiPPTCollapse: Action<ITemplateModel, boolean>;

    hasReplaceAiPPTTemplate: boolean;
    setHasReplaceAiPPTTemplate: Action<ITemplateModel, boolean>;

    setDynamicBgInfo: Action<ITemplateModel, { dynamicInfo: IDynamicInfoProps; previewUrl: string } | undefined>;

    setPsdFileUrl: Action<ITemplateModel, string>;

    setQrCode: Action<ITemplateModel, string>;
    setServerTemplateId: Action<ITemplateModel, string>;
    setMCPSourceId: Action<ITemplateModel, string>;

    setUseWatermark: Action<ITemplateModel, boolean>;

    setTagInfoId: Action<ITemplateModel, string>;
}

/** 设置编辑器舞台为：单画布模式 或 多画布模式（长图） */
function setEditorInstanceStageType(canvasType: CanvasType) {
    editor.stage.setType(
        (canvasType as unknown as StageType) === StageType.VARIETY ? StageType.VARIETY : StageType.SINGLE,
    );
}

export const templateModel: ITemplateModel = {
    destroy: action((state) => {
        state.originMaterialId = '';
        state.aiPicMapByLayerId = {};
        state.template = undefined;
        state.templateName = '';
        state.preview = '';
        state.version = '';
        state.id = '';
        state.canvasType = CanvasType.NORMAL;
        state.resolution = DEFAULT_DPI;
    }),
    hasReplaceAiPPTTemplate: false,
    setHasReplaceAiPPTTemplate: action((state, hasReplaceAiPPTTemplate) => {
        state.hasReplaceAiPPTTemplate = hasReplaceAiPPTTemplate;
    }),
    // // 判断是否显示替换ai app模板
    canShowReplaceAiPPTCollapse: false,
    setCanReplaceAiPPTCollapse: action((state, canShowReplaceAiPPTCollapse) => {
        state.canShowReplaceAiPPTCollapse = canShowReplaceAiPPTCollapse;
    }),
    dynamicBgInfo: undefined,
    setDynamicBgInfo: action((state, dynamicBgInfo) => {
        state.dynamicBgInfo = dynamicBgInfo;
    }),
    extraInfo: {},

    setExtraInfo: action((state, extraInfo) => {
        state.extraInfo = {
            ...state.extraInfo,
            ...extraInfo,
        };
        if (state.extraInfo?.masterPage) {
            const coreApi = CoreAPI(editor.id);
            coreApi.setCustomData('masterPage', state.extraInfo.masterPage.layers);
        }
    }),
    aiPPTInfo: {
        // aiImageRemain: 0,
        aiStyleSelect: [],
        ai_tone_select: [],
        aiFuncSelect: [],
    },

    originMaterialId: '',

    aiPicMapByLayerId: {},

    template: undefined,

    templateName: '',

    preview: '',

    version: '',

    id: '',

    resolution: DEFAULT_DPI,

    canvasType: CanvasType.NORMAL,

    isReplaceTemplate: false,
    setIsReplaceTemplate: action((state, payload) => {
        state.isReplaceTemplate = payload;
    }),

    initTemplateInfo: action(
        (state, { id, version, preview, templateName, canvasType, originMaterialId, resolution }) => {
            if (id) {
                state.id = id;
            }
            if (preview) {
                state.preview = preview;
            }
            if (version) {
                state.version = version;
            }
            if (templateName) {
                state.templateName = templateName;
            }
            if (canvasType) {
                state.canvasType = canvasType;
            }
            if (originMaterialId) {
                state.originMaterialId = originMaterialId;
            }
            if (resolution) {
                state.resolution = resolution;
            }
            if (canvasType) {
                setEditorInstanceStageType(canvasType);
            }
        },
    ),

    setCanvasType: action((state, canvasType) => {
        state.canvasType = canvasType;
        setEditorInstanceStageType(canvasType);
    }),

    setTemplateId: action((state, id) => {
        state.id = id;
    }),

    setVersion: action((state, version) => {
        state.version = version;
    }),

    setPreview: action((state, preview) => {
        state.preview = preview;
    }),

    setTemplate: action((state, template) => {
        state.template = template;
    }),

    setTemplateName: action((state, name) => {
        state.templateName = name;
    }),

    setAiImageRemain: action((state) => {
        if (!state.aiPPTInfo) {
            return;
        }
        state.aiPPTInfo = {
            ...state.aiPPTInfo,
            // aiImageRemain: remain
        };
    }),

    setAiImageInfo: action((state, aiPPTInfo) => {
        state.aiPPTInfo = aiPPTInfo;
    }),

    setOriginMaterialId: action((state, originMaterialId) => {
        state.originMaterialId = originMaterialId;
    }),

    setAiPicMapByLayerId: action((state, aiPicMapByLayerId) => {
        state.aiPicMapByLayerId = Object.assign({}, state.aiPicMapByLayerId, aiPicMapByLayerId);
    }),
    setResolution: action((state, value) => {
        setDPI(value);
        state.resolution = value;
    }),

    psdFileUrl: '',
    setPsdFileUrl: action((state, psdFileUrl) => {
        state.psdFileUrl = psdFileUrl;
    }),

    qrCode: '',
    setQrCode: action((state, qrCode) => {
        state.qrCode = qrCode;
    }),
    setServerTemplateId: action((state, serverTemplateId) => {
        state.templateId = serverTemplateId;
    }),
    setMCPSourceId: action((state, mcpSourceId) => {
        state.mcpSourceId = mcpSourceId;
    }),

    setUseWatermark: action((state, useWatermark) => {
        state.useWatermark = useWatermark;
    }),

    useWatermark: true,

    tagInfoId: undefined,
    setTagInfoId: action((state, tagInfoId) => {
        state.tagInfoId = tagInfoId;
    }),
};
